import {
    dispatch as D3dispatch,
    arc as D3arc,
    select as D3select,
    pointer as D3pointer,
    scaleLinear as D3scaleLinear,
} from 'd3';

// a brush over an area chart
const D3PieBrush = function () {
    const CIRCLE = 2 * Math.PI;
    let extent = [0, CIRCLE];
    // TODO: get our other brcd3 components to use this cooler way of exposing event hooks
    const dispatch = D3dispatch('start', 'end', 'brush');
    const scale = D3scaleLinear().domain(extent).range(extent);
    const arc = D3arc();
    let brushg;
    let or;
    let ir;
    let handlePath;
    let nobPath;

    function my (selection) {
        if (!selection) return;
        selection.each(function (data, i) {
            arc.startAngle(d => d.startAngle)
                .endAngle(d => d.endAngle);

            // g added only once on enter
            brushg = D3select(this).selectAll('.pi.brush').data([data]);
            brushg = brushg.enter()
                .append('g')
                .attr('class', 'pi brush')
                .merge(brushg);

            brushg.selectAll('path.brush')
                .data([{ key: 'sel', startAngle: extent[0], endAngle: extent[1] }], d => d.key)
                .enter()
                .insert('path')
                .attr('d', arc)
                .attr('class', 'brush selection')
                .style('stroke-width', 2)
                .on('mousedown.brush', start);

            const hdata = [
                { key: 'e', a: extent[0] },
                { key: 'w', a: extent[1] }];

            // dust off the trig
            handlePath = d => {
                // handle points
                const p1 = (Math.cos(d.a - Math.PI / 2) * (ir - 10)) + ' ' +
                      (Math.sin(d.a - Math.PI / 2) * (ir - 10));
                const p2 = (Math.cos(d.a - Math.PI / 2) * (or + 10)) + ' ' +
                    (Math.sin(d.a - Math.PI / 2) * (or + 10));
                // draw a straight line
                return 'M' + p1 + ' L ' + p2;
            };
            nobPath = d => {
                // nobs size relative to inner and outer radius
                const hs = (or - ir) < 10 ? (or - ir) : 10;
                // nob locations
                const c = ir + (or - ir) / 2;
                const p1 = (Math.cos(d.a - Math.PI / 2) * (c - hs)) + ' ' +
                      (Math.sin(d.a - Math.PI / 2) * (c - hs));
                const p2 = (Math.cos(d.a - Math.PI / 2) * (c + hs)) + ' ' +
                    (Math.sin(d.a - Math.PI / 2) * (c + hs));
                // draw half-circles concave and convex
                return 'M' + p1 + ' A 1 1 0 0 ' + (d.key === 'e' ? 1 : 0) + p2;
            };

            const handles = brushg.selectAll('.handle-bar')
                .data(hdata, d => d.key);
            handles.enter()
                .append('path')
                .attr('class', 'handle-bar pi handle')
                .merge(handles)
                .attr('d', handlePath)
                .on('mousedown.brush', start)
                .on('dblclick', (e, d) => {
                    if (d.key === 'e') {
                        move([0, extent[1]]);
                        end();
                    } else if (d.key === 'w') {
                        move([extent[0], CIRCLE]);
                        end();
                    }
                });

            const nobs = brushg.selectAll('.handle-nob')
                .data(hdata, d => d.key);
            nobs.enter()
                .append('path')
                .attr('class', 'handle-nob pi handle')
                .merge(nobs)
                .attr('d', nobPath)
                .on('mousedown.brush', start)
                .on('dblclick', (e, d) => {
                    if (d.key === 'e') {
                        move([0, extent[1]]);
                        end();
                    } else if (d.key === 'w') {
                        move([extent[0], CIRCLE]);
                        end();
                    }
                });
        });
    }

    // behavior
    const win = D3select(window);
    function start (e, d) {
        const start = D3pointer(e); // mouse(brushg.node());
        const sExtent = extent;
        win.on('mousemove.brush', (e) => movestart(e, d, start, sExtent))
            .on('mouseup.brush', end);
        dispatch.call('start', my, e, my.extent());
    }

    function movestart (e, d, origin, oExt) {
        const current = D3pointer(e); // mouse(brushg.node());
        const diff = Math.atan2(current[1], current[0]) - Math.atan2(origin[1], origin[0]);
        const nExt = JSON.parse(JSON.stringify(oExt));

        // figure out new positions
        if (d.key === 'e') {
            nExt[0] = Math.max(Math.min(oExt[0] + diff, oExt[1]), oExt[1] - CIRCLE);
            if (oExt[0] + diff > oExt[1]) {
                nExt[0] = oExt[0] + diff - CIRCLE;
            } else if (oExt[0] + diff < oExt[1] - CIRCLE) {
                nExt[0] = oExt[0] + diff + CIRCLE;
            }
        } else if (d.key === 'w') {
            nExt[1] = Math.min(Math.max(oExt[1] + diff, oExt[0]), oExt[0] + CIRCLE);
            if (oExt[1] + diff < oExt[0]) {
                nExt[1] = oExt[1] + diff + CIRCLE;
            } else if (oExt[1] + diff > oExt[0] + CIRCLE) {
                nExt[1] = oExt[1] + diff - CIRCLE;
            }
        } else {
            nExt[0] = oExt[0] + diff;
            nExt[1] = oExt[1] + diff;
        }

        move(nExt);
    }

    function move (next) {
        brushg.selectAll('path.brush')
            .data([{ key: 'sel', startAngle: next[0], endAngle: next[1] }], d => d.key)
            .attr('d', arc);

        const hdata = [
            { key: 'e', a: next[0] },
            { key: 'w', a: next[1] }];

        brushg.selectAll('.handle-bar')
            .data(hdata, d => d.key)
            .attr('d', handlePath);

        brushg.selectAll('.handle-nob')
            .data(hdata, d => d.key)
            .attr('d', nobPath);

        // don't get all wound up around the circle
        const nnExt = JSON.parse(JSON.stringify(next));
        nnExt[0] = next[0] + (next[0] > CIRCLE ? -CIRCLE : (next[0] < -CIRCLE ? CIRCLE : 0));
        nnExt[1] = next[1] + (next[1] > CIRCLE ? -CIRCLE : (next[1] < -CIRCLE ? CIRCLE : 0));
        extent = next;
        dispatch.call('brush', my, undefined, my.extent());
    }

    function end (e) {
        // bubble up
        win.on('mousemove.brush', null)
            .on('mouseup.brush', null);
        dispatch.call('end', my, e, my.extent());
    }

    // getters/setters
    my.move = function (v) {
        const nExt = !arguments.length ? [0, CIRCLE] : [scale.invert(v[0]), scale.invert(v[1])];
        nExt[1] = nExt[1] < nExt[0] ? nExt[1] + CIRCLE : nExt[1];
        move(nExt);
        return my;
    };

    my.extent = function (v) {
        const a = d => d === CIRCLE ? d : (d % CIRCLE) < 0 ? CIRCLE + (d % CIRCLE) : (d % CIRCLE);
        if (!arguments.length) return [scale(a(extent[0])), scale(a(extent[1]))];
        extent = [scale.invert(v[0]), scale.invert(v[1])];
        return my;
    };

    my.innerRadius = function (v) {
        if (!arguments.length) return ir;
        ir = v;
        arc.innerRadius(d => d.key !== 'sel' ? v - 10 : v);
        return my;
    };

    my.outerRadius = function (v) {
        if (!arguments.length) return or;
        or = v;
        arc.outerRadius(d => d.key !== 'sel' ? v + 10 : v);
        return my;
    };

    my.range = function (v) {
        if (!arguments.length) return scale.range();
        scale.range(v);
        return my;
    };

    my.on = function () {
        const value = dispatch.on.apply(dispatch, arguments);
        return value === dispatch ? my : value;
    };

    return my;
};

export default D3PieBrush;
